export default __webpack_public_path__ + "static/media/prev-arrow.aee70848.svg";